import { useNavigate } from "react-router-dom";
import "./Settings.scss";
import { useEffect, useState } from "react";
import images from "../../../assets/Icons/Icons";
import { useCurrentUser } from "../../../hooks/useGetUserDetail";
import { useSchoolHierarchy } from "../../../hooks/useSchoolHierarchy";
import { SectionLoader } from "../../../components/Loader/sectionLoader";
import { toast } from "react-toastify";
import { usePostHelpContactSupport } from "../../../hooks/useFeedback";
import ConfirmModal from "../../../components/ConfirmModal/ConfirmModal";
import { trackEvent } from "../../../mixpanel";
import { triggerLogout } from "../../../auth/logout";

const Settings = () => {
  const [showSupport, setShowSupport] = useState(true);
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Track profile view on mount
  useEffect(() => {
    trackEvent("PROFILE_VIEWED", {});
  }, []);

  const handleLogout = () => triggerLogout("manual");

  const { data: user } = useCurrentUser();
  const { data: schoolHData, loading } = useSchoolHierarchy({
    schoolHash: user?.schoolHash,
    enabled: !!user?.schoolHash,
  });

  const { postHelpContactSupport } = usePostHelpContactSupport();

  const [form, setForm] = useState({
    name: "",
    email: "",
    schoolName: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);

  // Prefill form when data arrives
  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      name: user?.name || "",
      email: user?.email || "",
      schoolName: schoolHData?.schoolName || "",
    }));
  }, [user, schoolHData]);

  const navigateToDashboard = () => {
    navigate("/dashboard");
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.message.trim()) {
      toast.error("Please describe your concern");
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
        name: form.name,
        email: form.email,
        description: form.message,
        recipientEmail: "sudha@yetimyfriend.com",
      };

      const res: any = await postHelpContactSupport(payload);
      if (res) {
        toast.success("Support request submitted successfully!");

        // Track support request submission
        trackEvent("SUPPORT_REQUEST_SUBMITTED");

        setForm((prev) => ({ ...prev, message: "" }));
      } else {
        toast.error("Failed to submit request");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="settings-page">
      {/* Header */}
      <div className="settings-header">
        <div onClick={navigateToDashboard} className="left">
          <img
            src={images.backIcon}
            className="back-arrow"
            alt="back"
            width={24}
            height={24}
          />
          <h2>Settings</h2>
        </div>
      </div>

      <div className="divider" />

      {/* Teacher Dashboard */}
      <section className="teacher-dashboard">
        {loading ? (
          <SectionLoader />
        ) : (
          <>
            <div className="field">
              <label className="labels">Teacher’s name</label>
              <input className="inputTitle" value={user?.name || ""} readOnly />
            </div>

            <div className="field">
              <label className="labels">Teacher’s email</label>
              <p className="readonly readonly--email">{user?.email || ""}</p>
            </div>

            <div className="field">
              <label className="labels">School name</label>
              <input
                readOnly
                className="readonly"
                value={schoolHData?.schoolName || "-"}
              />
            </div>
          </>
        )}
      </section>

      <div className="divider" />

      {/* Contact Support */}
      <section className="support-card">
        <div
          className="support-header"
          onClick={() => setShowSupport(!showSupport)}
        >
          <div className="title">
            <img
              src={images.askIcon}
              className="icon"
              alt="ask"
              width={20}
              height={25}
            />
            <h4>Contact support</h4>
          </div>
          <img
            src={showSupport ? images.upIocn : images.downIcon}
            width={24}
            height={24}
          />
        </div>

        {showSupport && (
          <div className="support-body">
            <input
              readOnly
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
            />
            <input
              readOnly
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
            />
            {/* <input
              name="schoolName"
              placeholder="School name"
              value={form.schoolName}
              onChange={handleChange}
            /> */}
            <textarea
              name="message"
              placeholder="Describe your concern here..."
              value={form.message}
              onChange={handleChange}
            />

            <div className="submit-wrapper">
              <button
                className="submit-btn"
                onClick={handleSubmit}
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit request"}
              </button>
            </div>
          </div>
        )}
      </section>

      <div className="divider" />

      {/* Logout */}
      <div className="logouts" onClick={() => setShowLogoutModal(true)}>
        <img
          src={images.logouticon}
          className="logout-icon"
          alt="Logout"
          width={34}
          height={34}
        />
        <span className="logout-text">Log out</span>
      </div>
      <ConfirmModal
        isOpen={showLogoutModal}
        title="Confirm Logout"
        message="Are you sure you want to log out?"
        confirmText="Log out"
        cancelText="Cancel"
        onConfirm={handleLogout}
        onCancel={() => setShowLogoutModal(false)}
      />
    </div>
  );
};

export default Settings;
